import { isValidElement as n, cloneElement as r } from "react";
const s = ({
  children: t,
  template: e,
  asChild: m,
  props: o
}) => n(t) ? m ? r(
  t,
  t.props,
  e({ ...o, children: t.props.children })
) : e({ ...o, children: t }) : e({ ...o, children: t }), u = s;
export {
  s as useSlottedTemplate,
  u as withSlottedTemplate
};
